<template>
	<div :class="['table__filters', { 'skeleton': loading }]">
		<helio-button
			v-for="(filter, index) in Object.keys(parsedFilters)"
			:key="index"
			class="table__filter"
			:class="[
				`table__filter--${parsedFilters[filter].status}`,
				{ 'table__filter--selected': parsedFilters[filter].identifier === currentFilter }
			]"
			:icon="parsedFilters[filter].iconToken"
			icon-weight="bold"
			:icon-color="parsedFilters[filter].status"
			:text="getName(parsedFilters[filter])"
			@click="select(filter)"
		/>
	</div>
</template>

<script>
import Button from '../../button/Button.vue';

export default {
	name: 'Filters',

	components: {
		'helio-button': Button,
	},

	props: {
		items: {
			type: Array,
			required: true,
		},

		filters: {
			type: Array,
			required: true,
		},

		loading: {
			type: Boolean,
			required: false,
			default: false,
			description: 'Sets whether the filters will be shown in its loading state',
		},
	},

	data() {
		return {
			parsedFilters: {},
			currentFilter: null,
		};
	},

	watch: {
		filters() {
			this.parseFilters();
		},

		items: {
			handler() {
				this.parseFilters();
			},
			deep: true,
		},
	},

	mounted() {
		this.parseFilters();
	},

	methods: {
		parseFilters() {
			this.parsedFilters = {};

			this.filters.forEach((filter) => {
				const results = this.items.filter((item) => filter.condition(item));
				this.$set(this.parsedFilters, filter.identifier, { ...filter, results });
			});
		},

		select(identifier) {
			const filter = this.parsedFilters[identifier];
			this.currentFilter = this.currentFilter !== filter.identifier ? filter.identifier : null;
			this.$emit('filter', filter);
		},

		getName(filter) {
			const count = filter.results.length;

			// Really don't know why $tc pluralization is not working out-of-box here
			// for the replacement of count, had to add a replace() to make it work
			return this.$tc(filter.name, count, { count }).replace('{count}', count);
		},
	},
};
</script>

<style lang="text/scss" src="./filters.scss" />
